/* tslint:disable */
/* eslint-disable */
/**
 * BonusX
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { DocumentStructure } from '../models';
/**
 * AdminDocumentStructureApi - axios parameter creator
 * @export
 */
export const AdminDocumentStructureApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *  **Permission required**: [\"readAll\", \"DocumentStructure\"] 
         * @summary Get all document structures
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allAdminDocumentStructure: async (filter?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/documentStructure/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  **Permission required**: [\"create\", \"DocumentStructure\"] 
         * @summary Create a new document structure
         * @param {DocumentStructure} [documentStructure] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDocumentStructure: async (documentStructure?: DocumentStructure, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/documentStructure/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentStructure, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  **Permission required**: [\"create\", \"DocumentStructure\"] 
         * @summary Edit a service
         * @param {DocumentStructure} [documentStructure] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editDocumentStructure: async (documentStructure?: DocumentStructure, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/documentStructure/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentStructure, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  **Permission required**: [\"readOne\", \"DocumentStructure\"] 
         * @summary Get a single Document Structure
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminDocumentStructureById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAdminDocumentStructureById', 'id', id)
            const localVarPath = `/admin/documentStructure/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminDocumentStructureApi - functional programming interface
 * @export
 */
export const AdminDocumentStructureApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminDocumentStructureApiAxiosParamCreator(configuration)
    return {
        /**
         *  **Permission required**: [\"readAll\", \"DocumentStructure\"] 
         * @summary Get all document structures
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allAdminDocumentStructure(filter?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DocumentStructure>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allAdminDocumentStructure(filter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDocumentStructureApi.allAdminDocumentStructure']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  **Permission required**: [\"create\", \"DocumentStructure\"] 
         * @summary Create a new document structure
         * @param {DocumentStructure} [documentStructure] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDocumentStructure(documentStructure?: DocumentStructure, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentStructure>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDocumentStructure(documentStructure, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDocumentStructureApi.createDocumentStructure']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  **Permission required**: [\"create\", \"DocumentStructure\"] 
         * @summary Edit a service
         * @param {DocumentStructure} [documentStructure] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editDocumentStructure(documentStructure?: DocumentStructure, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentStructure>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editDocumentStructure(documentStructure, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDocumentStructureApi.editDocumentStructure']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  **Permission required**: [\"readOne\", \"DocumentStructure\"] 
         * @summary Get a single Document Structure
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminDocumentStructureById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentStructure>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminDocumentStructureById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDocumentStructureApi.getAdminDocumentStructureById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminDocumentStructureApi - factory interface
 * @export
 */
export const AdminDocumentStructureApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminDocumentStructureApiFp(configuration)
    return {
        /**
         *  **Permission required**: [\"readAll\", \"DocumentStructure\"] 
         * @summary Get all document structures
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allAdminDocumentStructure(filter?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DocumentStructure>> {
            return localVarFp.allAdminDocumentStructure(filter, options).then((request) => request(axios, basePath));
        },
        /**
         *  **Permission required**: [\"create\", \"DocumentStructure\"] 
         * @summary Create a new document structure
         * @param {DocumentStructure} [documentStructure] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDocumentStructure(documentStructure?: DocumentStructure, options?: RawAxiosRequestConfig): AxiosPromise<DocumentStructure> {
            return localVarFp.createDocumentStructure(documentStructure, options).then((request) => request(axios, basePath));
        },
        /**
         *  **Permission required**: [\"create\", \"DocumentStructure\"] 
         * @summary Edit a service
         * @param {DocumentStructure} [documentStructure] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editDocumentStructure(documentStructure?: DocumentStructure, options?: RawAxiosRequestConfig): AxiosPromise<DocumentStructure> {
            return localVarFp.editDocumentStructure(documentStructure, options).then((request) => request(axios, basePath));
        },
        /**
         *  **Permission required**: [\"readOne\", \"DocumentStructure\"] 
         * @summary Get a single Document Structure
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminDocumentStructureById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<DocumentStructure> {
            return localVarFp.getAdminDocumentStructureById(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminDocumentStructureApi - interface
 * @export
 * @interface AdminDocumentStructureApi
 */
export interface AdminDocumentStructureApiInterface {
    /**
     *  **Permission required**: [\"readAll\", \"DocumentStructure\"] 
     * @summary Get all document structures
     * @param {string} [filter] page, perPage, order, orderBy, filter (object)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDocumentStructureApiInterface
     */
    allAdminDocumentStructure(filter?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DocumentStructure>>;

    /**
     *  **Permission required**: [\"create\", \"DocumentStructure\"] 
     * @summary Create a new document structure
     * @param {DocumentStructure} [documentStructure] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDocumentStructureApiInterface
     */
    createDocumentStructure(documentStructure?: DocumentStructure, options?: RawAxiosRequestConfig): AxiosPromise<DocumentStructure>;

    /**
     *  **Permission required**: [\"create\", \"DocumentStructure\"] 
     * @summary Edit a service
     * @param {DocumentStructure} [documentStructure] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDocumentStructureApiInterface
     */
    editDocumentStructure(documentStructure?: DocumentStructure, options?: RawAxiosRequestConfig): AxiosPromise<DocumentStructure>;

    /**
     *  **Permission required**: [\"readOne\", \"DocumentStructure\"] 
     * @summary Get a single Document Structure
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDocumentStructureApiInterface
     */
    getAdminDocumentStructureById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<DocumentStructure>;

}

/**
 * AdminDocumentStructureApi - object-oriented interface
 * @export
 * @class AdminDocumentStructureApi
 * @extends {BaseAPI}
 */
export class AdminDocumentStructureApi extends BaseAPI implements AdminDocumentStructureApiInterface {
    /**
     *  **Permission required**: [\"readAll\", \"DocumentStructure\"] 
     * @summary Get all document structures
     * @param {string} [filter] page, perPage, order, orderBy, filter (object)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDocumentStructureApi
     */
    public allAdminDocumentStructure(filter?: string, options?: RawAxiosRequestConfig) {
        return AdminDocumentStructureApiFp(this.configuration).allAdminDocumentStructure(filter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  **Permission required**: [\"create\", \"DocumentStructure\"] 
     * @summary Create a new document structure
     * @param {DocumentStructure} [documentStructure] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDocumentStructureApi
     */
    public createDocumentStructure(documentStructure?: DocumentStructure, options?: RawAxiosRequestConfig) {
        return AdminDocumentStructureApiFp(this.configuration).createDocumentStructure(documentStructure, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  **Permission required**: [\"create\", \"DocumentStructure\"] 
     * @summary Edit a service
     * @param {DocumentStructure} [documentStructure] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDocumentStructureApi
     */
    public editDocumentStructure(documentStructure?: DocumentStructure, options?: RawAxiosRequestConfig) {
        return AdminDocumentStructureApiFp(this.configuration).editDocumentStructure(documentStructure, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  **Permission required**: [\"readOne\", \"DocumentStructure\"] 
     * @summary Get a single Document Structure
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDocumentStructureApi
     */
    public getAdminDocumentStructureById(id: number, options?: RawAxiosRequestConfig) {
        return AdminDocumentStructureApiFp(this.configuration).getAdminDocumentStructureById(id, options).then((request) => request(this.axios, this.basePath));
    }
}

